<template>
  <div ref="test">
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem :to="{name: 'meeting-list',  query: { t: + new Date() }}">活动管理</BreadcrumbItem>
      <BreadcrumbItem>活动列表</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <div style="text-align: right; width: 400px; margin: 0 auto 20px">
        <Input v-model.trim="searchKeyword" @on-enter="search(1)" size="large" placeholder="输入活动名称搜索">
        <Button slot="append" type="primary" icon="ios-search" @click="search(1)">搜索</Button>
        </Input>
      </div>
      <div style="width: 80%">
<!--        <Alert v-if="shouldShowPosterInfo()" show-icon closable @on-close="handleClosePosterInfo">操作列新增 [下载活动海报] 功能，可以选择三种海报样式，快速生成海报图片。-->
<!--        <span slot="close">我知道了</span>-->
<!--        </Alert>-->
      </div>
      <Card class="meeting-list-card">
        <p slot="title" class="meeting-list-title">
          <Icon type="ios-list-outline"></Icon>
          活动列表
          <span v-if="loginUser.parentAdminUserId !== 1 && loginUser.orgId" class="all-meetings-switch">
            <i-switch v-model="includeParentOrgMeetings" @on-change="search(1)"></i-switch>
            <span class="all-meetings-switch-label">查看所有活动</span>
          </span>
<!--          <Input >-->
<!--          <Button slot="append" icon="ios-search"></Button>-->
<!--          </Input>-->
        </p>
        <div slot="extra" class="meeting-list-extra">
          <router-link :to="{name: 'meeting-calendar'}">
            <Icon type="ios-calendar-outline"></Icon>
            日历
          </router-link>
          <router-link :to="{name: 'meeting-create'}">
            <Icon type="ios-paperplane"></Icon>
            创建活动
          </router-link>
        </div>
        <Alert v-if="hasDateFilter" show-icon class="meeting-date-filter-alert">
          当前仅查看 {{ dateFilterText }} 的活动
          <Button type="text" size="small" @click="clearDateFilter">查看全部活动</Button>
        </Alert>
        <Table :columns="columns" :data="rows" :show-header="true"></Table>
        <Page :total="totalCount" :page-size="pageSize" :current.sync="currentPage" show-total show-elevator @on-change="handlePageChange" style="margin-top: 10px; text-align: right" />
      </Card>
    </div>
    <Modal
        v-model="showDelaySignUp"
        title="继续报名"
        @on-ok="delaySignUpEndDate()">
      <Form ref="formValidate" class="meeting-form" :rules="ruleValidate">
        <FormItem label="新的报名截止时间">
          <DatePicker v-model="newSignUpEndDate" type="datetime" :options="delayOption" size="large" show-week-numbers placeholder="设置新的报名截止时间"
                      format="yyyy-MM-dd HH:mm" style="width: 100%"></DatePicker>
        </FormItem>
      </Form>
    </Modal>
    <Modal
        v-model="showNoteModal"
        title="编辑备注"
        :mask-closable="false"
        @on-ok="handleConfirmNote()"
        :styles="{top: '10px'}"
        width="700">
      <Form ref="formValidate" label-position="top" >
        <FormItem label="备注">
          <Input v-model.trim="newNote" type="textarea"></Input>
        </FormItem>
      </Form>
    </Modal>

    <Modal
        v-model="showOBSConfig"
        title="生成推流地址">
      <Form ref="formValidate" class="meeting-form" :rules="ruleValidate">
        <FormItem label="直播有效期：通常设定为会议结束时间后4到8小时">
          <DatePicker v-model="selectedOBSMeeting.liveExpiredTime" type="datetime" :options="delayOption" size="large" show-week-numbers placeholder="设置直播有效期"
                      format="yyyy-MM-dd HH:mm" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem>
          <Button type="primary"  size="small"  @click="generatePushStreamAddress">生成地址</Button>
        </FormItem>
        <div>
          <Alert>提示：请将OBS推流地址和OBS推流名称配置在OBS软件设置->推流的服务器和串流秘钥。</Alert><br>
          类型：推流域名 <br>
          过期时间：{{ formatDateWithPattern(selectedOBSMeeting.liveExpiredTime, 'YYYY-MM-DD HH:mm') }}<br>
          推流地址：{{ obsConfig.obsPushStreamAddress ? obsConfig.obsPushStreamAddress + obsConfig.obsPushStreamName : '' }}<br>
          OBS推流地址：{{ obsConfig.obsPushStreamAddress }}<br>
          OBS推流名称：{{ obsConfig.obsPushStreamName }}
        </div>
      </Form>
    </Modal>

    <Modal
        v-model="showChangeUser"
        title="更换创建人和发布人"
        @on-ok="handleChangeMeetingUser()" >
      <Form ref="formValidate" class="meeting-form" :rules="ruleValidate">
        <div>
          活动名称：{{ changedMeeting.title }}<br>
        </div>
        <FormItem label="将创建人和发布人替换为：">
          <Select
              v-model="changedMeeting.userId"
              filterable
              :remote-method="searchUser"
              :loading="loadingSearchUser"
              placeholder="选择用户">
            <Option v-for="user in allUsers" :key="user.id"
                    :value="user.id">{{ user.nickname }}({{ user.name }})</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>

import Vue from 'vue'
import moment from 'moment'
import { mapState } from 'vuex'
import MeetingInfoCell from './components/MeetingInfoCell'
import Cookies from 'js-cookie'

export default {
  name: 'MeetingList',
  components: {
    MeetingInfoCell
  },
  data () {
    return {
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      remoteStatus: null,
      meetings: [],
      includeParentOrgMeetings: false,
      startDate: null,
      endDate: null,
      showOBSConfig: false,
      showDelaySignUp: false,
      delaySignUpMeetingId: null,
      selectedOBSMeeting: {},
      newSignUpEndDate: null,
      tableLoading: true,
      newNote: '',
      allUsers: [],
      updateNoteMeetingId: null,
      showNoteModal: false,
      searchKeyword: null,
      changedMeeting: {},
      showChangeUser: false,
      loadingSearchUser: false,
      delayOption: {
        disabledDate (date) {
          return date.valueOf() < Date.now()
        }
      },
      obsConfig: {},
      tableColumns: [
        {
          title: ' ',
          key: 'cover',
          width: 170,
          render: (h, params) => {
            return h('div', [
              h('img', {
                attrs: {
                  width: '160',
                  height: '100',
                  src: `/api/admin/meetings/cover/show?path=${params.row.coverImgPath}`
                },
                style: {
                  'vertical-align': 'middle'
                }
              })
            ])
          }
        },
        {
          title: '活动信息',
          key: 'title',
          render: (h, params) => {
            return h(MeetingInfoCell, {
              props: {
                row: params.row
              }
            })
          }
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          render: (h, params) => {
            return h('div', this.getStatusText(params.row.status))
          }
        },

        {
          title: '操作',
          width: 200,
          render: (h, params) => {
            let elements = []
            if (this.haveOperationPermissions(params.row.creatorAdminUserId)) {
              if (params.row.status === 0) {
                elements.push(h('p', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.publish(params.row.id)
                      }
                    }
                  }, '发布活动')]))
              }

              if (params.row.status === 0) {
                elements.push(h('p', [
                  h('Button', {
                    props: {
                      type: 'warning',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.directedPublish(params.row.id)
                      }
                    }
                  }, '定向发布活动')]))
              }

              elements.push(h('p', [
                h('Badge', {
                  props: {
                    count: params.row.waitToReviewSignInCount
                  }}, [
                  h('Button', {
                    props: {
                      type: 'default',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.$router.push(`/meetings/${params.row.id}/signs`)
                      }
                    }
                  }, `报名管理`)
                ])]))

              if (params.row.signSetting && params.row.signSetting.showInvoice) {
                elements.push(h('p', [
                  h('Button', {
                    props: {
                      type: 'default',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.$router.push(`/meetings/${params.row.id}/invoices`)
                      }
                    }
                  }, '发票管理')]))
              }
              elements.push(h('p', [
                h('Button', {
                  props: {
                    type: 'default',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push(`/meetings/${params.row.id}/detail`)
                    }
                  }
                }, '活动详情')]))

              elements.push(h('p', [
                h('Button', {
                  props: {
                    type: 'default',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push(`/meetings/${params.row.id}/sign/setting`)
                    }
                  }
                }, '设置报名项')]))

              elements.push(h('p', [
                h('Button', {
                  props: {
                    type: 'default',
                    size: 'small'
                  },
                  // style: {
                  //   position: 'relative'
                  // },
                  on: {
                    click: () => {
                      this.$router.push(`/meetings/${params.row.id}/poster`)
                    }
                  }
                }, '下载活动海报')
              ]))

              elements.push(h('p', [
                h('Button', {
                  props: {
                    type: 'default',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push(`/meetings/${params.row.id}/SignIn`)
                    }
                  }
                }, '签到管理')]))

              if (params.row.status !== 0) {
                let singInQRCodeImgName = `${params.row.title}_签到码.png`
                let signInQRCodeImgLink = `https://bizevent.ccpit.org/meetings/${params.row.id}/signIn`
                elements.push(h('p', [
                  h('a', {
                    domProps: {
                      href: `/api/admin/matrixToImage/downloadImg?plainText=${signInQRCodeImgLink}&imgName=${singInQRCodeImgName}`
                    },
                    'class': 'link-btn'
                  }, '下载签到码')]))
              }

              let dropdownItems = []
              if (params.row.status === 2) {
                dropdownItems.push(h('DropdownItem', [h('Button', {props: {type: 'text', size: 'small'},
                  on: {
                    click: () => {
                      this.updateStatus(params.row.id, 3)
                    }
                  }
                }, '结束报名')]))
              }
              if (params.row.status === 3) {
                dropdownItems.push(h('DropdownItem', [h('Button', {props: {type: 'text', size: 'small'},
                  on: {
                    click: () => {
                      this.showDelaySignUp = true
                      this.delaySignUpMeetingId = params.row.id
                      this.newSignUpEndDate = new Date()
                    }
                  }
                }, '继续报名')]))
              }
              if (this.loginUser.parentAdminUserId === 1) {
                dropdownItems.push(h('DropdownItem', [h('Button', {props: {type: 'text', size: 'small'},
                  on: {
                    click: () => {
                      this.showChangeUser = true
                      this.changedMeeting = params.row
                    }
                  }
                }, '更换创建人')]))
              }
              if (params.row.status !== 0) {
                dropdownItems.push(h('DropdownItem', [h('Button', {props: {type: 'text', size: 'small'},
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `确定撤销发布活动【${params.row.title}】？`,
                        okText: '撤销',
                        cancelText: '取消',
                        onOk: () => {
                          this.revokePublish(params.row.id)
                        }
                      })
                    }
                  }
                }, '撤销发布')]))
              }
              dropdownItems.push(h('DropdownItem', [h('Button', {props: {type: 'text', size: 'small'},
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: `确认删除活动【${params.row.title}】？`,
                      okText: '确认删除',
                      cancelText: '取消',
                      onOk: () => {
                        this.delete(params.row.id)
                      }
                    })
                  }
                }
              }, '删除活动')]))
              elements.push(h('p', [
                h('Dropdown', {props: {placement: 'right-end', trigger: 'click'}}, [
                  h('Button', {props: {type: 'dashed', size: 'small'}}, [
                    '更多操作 ',
                    h('Icon', {
                      props: {
                        type: 'arrow-down-b'
                      }
                    })
                  ]),
                  h('DropdownMenu', {slot: 'list'}, dropdownItems)
                ])
              ]))
            } else {
              elements.push(h('p', [
                h('Badge', {
                  props: {
                    count: params.row.waitToReviewSignInCount
                  }}, [
                  h('Button', {
                    props: {
                      type: 'default',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.$router.push(`/meetings/${params.row.id}/signs`)
                      }
                    }
                  }, '报名情况')
                ])]))
              elements.push(h('p', [
                h('Button', {
                  props: {
                    type: 'default',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push(`/meetings/${params.row.id}/view`)
                    }
                  }
                }, '活动详情')]))
            }

            return h('div', {style: {'margin': '15px 2px'}}, elements)
          }
        }
      ],
      ruleValidate: {
        newSignUpEndDate: [
          {required: true, message: '请设置新的报名截止时间'}
        ]
      }
    }
  },
  computed: {
    ...mapState({
      loginUser: 'user'
    }),
    rows () {
      return this.meetings
    },
    hasDateFilter () {
      return !!(this.startDate || this.endDate)
    },
    dateFilterText () {
      let formatDate = value => {
        if (!value) {
          return ''
        }
        let rawValue = String(value)
        let date = /^\d+$/.test(rawValue) ? moment(Number(rawValue)) : moment(rawValue)
        return date.isValid() ? date.format('YYYY-MM-DD') : rawValue
      }
      let start = formatDate(this.startDate)
      let end = formatDate(this.endDate)
      if (start && end && start !== end) {
        return `${start} 至 ${end}`
      }
      return start || end || ''
    },
    columns () {
      let amdinOperations = {
        title: '管理活动',
        key: 'recommend',
        width: 140,
        render: (h, params) => {
          let self = this
          let elements = []
          elements.push(h('div', {style: {'margin': '5px 2px'}}, [
            h('span', '推荐：'),
            h('i-switch', {
              props: {
                size: 'large',
                value: params.row.recommend
              },
              on: {
                'on-change' (status) {
                  self.updateMeetingRecommend(params.row.id, status)
                  self.$emit('input', status)
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, '推荐'),
              h('span', {
                slot: 'close'
              }, '关闭')
            ])
          ]))

          elements.push(h('div', {style: {'margin': '5px 2px'}}, [
            h('span', '大平台直播：'),
            h('i-switch', {
              props: {
                size: 'large',
                value: params.row.forDptLive
              },
              on: {
                'on-change' (status) {
                  self.updateMeetingForDptLive(params.row.id, status)
                  self.$emit('input', status)
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, '共享'),
              h('span', {
                slot: 'close'
              }, '关闭')
            ])
          ]))

          elements.push(h('div', {style: {'margin': '5px 2px'}}, [
            h('span', '备注：'),
            h('span', {domProps: {innerHTML: params.row.note}}),
            h('Button', {
              props: {
                type: 'text',
                size: 'small'
              },
              on: {
                click: () => {
                  this.toShowNoteModal(params.row)
                }
              }}, [ h('Icon', {props: {type: 'ios-create-outline'}, style: {'font-size': '18px'}}) ])
          ]))
          return h('div', elements)
        }
      }

      let liveColumn = {
        title: '直播活动',
        key: 'live',
        width: 100,
        render: (h, params) => {
          let self = this
          let elements = []

          elements.push(h('div', {style: {'margin': '5px 2px'}}, [
            h('span', '直播中'),
            h('i-switch', {
              props: {
                size: 'large',
                value: params.row.live
              },
              on: {
                'on-change' (status) {
                  self.updateMeetingLive(params.row.id, status)
                  self.$emit('input', status)
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, '直播中'),
              h('span', {
                slot: 'close'
              }, '关闭')
            ])
          ]))
          elements.push(h('div', [
            h('a', {
              props: {
                href: 'javascript:void(0)'
              },
              on: {
                'click': () => {
                  this.toShowOBSModal(params.row)
                }
              }
            }, 'OBS配置')
          ]))
          elements.push(h('div', {style: {'margin': '5px 2px'}}, [
            h('span', '可回看'),
            h('i-switch', {
              props: {
                size: 'large',
                value: params.row.replayable
              },
              on: {
                'on-change' (status) {
                  self.updateMeetingReplayable(params.row.id, status)
                  self.$emit('input', status)
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, '可回看'),
              h('span', {
                slot: 'close'
              }, '关闭')
            ])
          ]))

          return h('div', elements)
        }
      }

      let ccoicRecommend = {
        title: '商会活动推荐',
        key: 'ccoicRecommend',
        width: 140,
        render: (h, params) => {
          let self = this
          return h('i-switch', {
            props: {
              size: 'large',
              value: params.row.ccoicRecommend
            },
            on: {
              'on-change' (status) {
                self.updateCcoicRecommend(params.row.id, status)
                self.$emit('input', status)
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, '推荐'),
            h('span', {
              slot: 'close'
            }, '关闭')
          ])
        }
      }

      let note = {
        title: '备注',
        key: 'note',
        width: 120,
        render: (h, params) => {
          return h('div', [
            h('span', {domProps: {innerHTML: params.row.note}}),
            h('Button', {
              props: {
                type: 'text',
                size: 'small'
              },
              on: {
                click: () => {
                  this.toShowNoteModal(params.row)
                }
              }
            }, [ h('Icon', {props: {type: 'ios-create-outline'}, style: {'font-size': '18px'}}) ])
          ])
        }
      }

      let columnShareData = {
        title: '预警共享',
        key: 'forYJ',
        width: 100,
        render: (h, params) => {
          let self = this
          return h('i-switch', {
            props: {
              size: 'large',
              value: params.row.forYJ
            },
            on: {
              'on-change' (status) {
                self.updateMeetingForYJ(params.row.id, status)
                self.$emit('input', status)
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, '共享'),
            h('span', {
              slot: 'close'
            }, '关闭')
          ])
        }
      }
      let ccoicOrgIds = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22]
      if (this.loginUser.parentAdminUserId === 1) {
        let col = this.tableColumns.slice(0)
        col.splice(2, 0, amdinOperations, liveColumn, ccoicRecommend)
        return col
      } else if (ccoicOrgIds.includes(this.loginUser.orgId)) {
        let col = this.tableColumns.slice(0)
        col.splice(2, 0, ccoicRecommend)
        return col
      } else {
        return this.tableColumns
      }
    }
  },
  watch: {
    searchKeyword (value) {
      this.search(1)
    }
  },
  methods: {
    shouldShowPosterInfo () {
      return !Cookies.get('close_poster_info')
    },
    handleClosePosterInfo () {
      Cookies.set('close_poster_info', '1')
    },
    haveOperationPermissions (creatorAdminUserId) {
      if (this.includeParentOrgMeetings) {
        return false
      }
      if (this.loginUser.parentAdminUserId === 1) {
        return true
      } else {
        return creatorAdminUserId != null && this.loginUser.parentAdminUserId === creatorAdminUserId
      }
    },
    getStatusText (status) {
      if (status === 0) {
        return '未发布'
      } else if (status === 1) {
        return '已发布'
      } else if (status === 2) {
        return '报名中'
      } else if (status === 3) {
        return '报名结束'
      } else if (status === 4) {
        return '活动结束'
      }
      return ''
    },
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD')
      } else {
        return null
      }
    },
    formatDateWithPattern (timestamp, pattern) {
      if (timestamp) {
        return moment(timestamp).format(pattern)
      } else {
        return null
      }
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
    },
    handlePageChange () {
      this.search(this.currentPage)
    },
    toShowNoteModal (meeting) {
      this.newNote = meeting.note
      this.updateNoteMeetingId = meeting.id
      this.showNoteModal = true
    },
    toShowOBSModal (meeting) {
      this.showOBSConfig = true
      this.obsConfig = {}
      this.selectedOBSMeeting = meeting
      if (this.selectedOBSMeeting.liveExpiredTime) {
        this.generatePushStreamAddress()
      }
    },
    async generatePushStreamAddress () {
      try {
        this.beforeSave()
        this.obsConfig = (await this.$http.post(`/api/admin/meetings/${this.selectedOBSMeeting.id}/live/pushStream/config`, {txTime: this.selectedOBSMeeting.liveExpiredTime})).body
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async handleConfirmNote () {
      try {
        this.beforeSave()
        await this.$http.patch(`/api/admin/meetings/${this.updateNoteMeetingId}/note`, {note: this.newNote})

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === this.updateNoteMeetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings[matchedIndex].note = this.newNote
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async handleChangeMeetingUser () {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${this.changedMeeting.id}/changeUser`, {userId: this.changedMeeting.userId})).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === this.changedMeeting.id) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async delaySignUpEndDate () {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${this.delaySignUpMeetingId}/delaySignUp`, {newSignUpEndDate: this.newSignUpEndDate})).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === this.delaySignUpMeetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
        this.newSignUpEndDate = null
        this.showDelaySignUp = false
        this.delaySignUpMeetingId = null
      } catch (e) {
        this.afterSave(e)
      }
    },
    async updateMeetingRecommend (meetingId, isRecommend) {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${meetingId}/updateRecommend`, {isRecommend: isRecommend})).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async updateCcoicRecommend (meetingId, isRecommend) {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${meetingId}/updateCcoicRecommend`, {isRecommend: isRecommend})).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async updateMeetingForYJ (meetingId, forYJ) {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${meetingId}/forYJ`, {forYJ: forYJ})).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async updateMeetingForDptLive (meetingId, forDptLive) {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${meetingId}/forDptLive`, {forDptLive: forDptLive})).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async updateMeetingLive (meetingId, live) {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${meetingId}/live`, {live: live})).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async updateMeetingReplayable (meetingId, replayable) {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${meetingId}/replayable`, {replayable: replayable})).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async updateStatus (meetingId, status) {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${meetingId}/updateStatus`, {status: status})).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async revokePublish (meetingId) {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${meetingId}/revokePublish`)).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async delete (meetingId) {
      try {
        this.beforeSave()
        await this.$http.delete(`/api/admin/meetings/${meetingId}`)

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async publish (meetingId) {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${meetingId}/publish`)).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async directedPublish (meetingId) {
      try {
        this.beforeSave()
        let updatedMeeting = (await this.$http.patch(`/api/admin/meetings/${meetingId}/directedPublish`)).body

        let matchedIndex = -1
        this.meetings.forEach((item, index) => {
          if (item.id === meetingId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.meetings.splice(matchedIndex, 1, updatedMeeting)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async search (startPage) {
      try {
        this.$Loading.start()
        let queryStr = `page=${startPage}&size=${this.pageSize}&name=${this.searchKeyword ? encodeURIComponent(this.searchKeyword) : ''}&includeParentOrgMeetings=${this.includeParentOrgMeetings}`
        if (this.startDate) {
          queryStr += `&startDate=${this.startDate}`
        }
        if (this.endDate) {
          queryStr += `&endDate=${this.endDate}`
        }
        let resp = (await this.$http.get(`/api/admin/meetings?${queryStr}`)).body
        this.totalCount = resp.totalCount
        this.totalPage = resp.totalPage
        this.meetings = resp.meetings
        this.$Loading.finish()
      } catch (e) {
        this.afterSave(e)
      }
    },
    clearDateFilter () {
      this.startDate = null
      this.endDate = null
      this.currentPage = 1
      let query = Object.assign({}, this.$route.query)
      delete query.startDate
      delete query.endDate
      this.$router.replace({name: 'meeting-list', query})
      this.search(1)
    },
    async searchUser (keyword) {
      try {
        this.loadingSearchUser = true
        let queryStr = keyword ? `?keyword=${keyword}` : ''
        let resp = (await this.$http.get(`/api/admin/users/all${queryStr}`)).body
        this.allUsers = resp
        this.loadingSearchUser = false
      } catch (e) {
        this.afterSave(e)
      } finally {
        this.loadingSearchUser = false
      }
    }
  },
  async mounted () {
    try {
      this.startDate = this.$route.query.startDate || null
      this.endDate = this.$route.query.endDate || null
      if (this.$route.query.includeParentOrgMeetings !== undefined) {
        this.includeParentOrgMeetings = this.$route.query.includeParentOrgMeetings === true || this.$route.query.includeParentOrgMeetings === 'true'
      }
      this.searchKeyword = this.$route.query.name || null
      let queryStr = `page=1&size=${this.pageSize}&includeParentOrgMeetings=${this.includeParentOrgMeetings}`
      if (this.searchKeyword) {
        queryStr += `&name=${encodeURIComponent(this.searchKeyword)}`
      }
      if (this.startDate) {
        queryStr += `&startDate=${this.startDate}`
      }
      if (this.endDate) {
        queryStr += `&endDate=${this.endDate}`
      }
      let resp = await Vue.http.get(`/api/admin/meetings?${queryStr}`)
      this.remoteStatus = resp.status
      this.totalCount = resp.body.totalCount
      this.totalPage = resp.body.totalPage
      this.meetings = resp.body.meetings
      if (this.loginUser.parentAdminUserId === 1) {
        this.searchUser()
      }
      // next()
    } catch (e) {
      this.remoteStatus = e.status
      this.meetings = []
      // next()
    }
  }
  // async beforeRouteEnter (to, from, next) {
  //   try {
  //     let resp = await Vue.http.get('/api/admin/meetings?page=1&size=10')
  //     next(vm => {
  //       vm.remoteStatus = resp.status
  //       vm.totalCount = resp.body.totalCount
  //       vm.totalPage = resp.body.totalPage
  //       vm.meetings = resp.body.meetings
  //       vm.searchKeyword = null
  //     })
  //   } catch (e) {
  //     next(vm => {
  //       vm.remoteStatus = e.status
  //       vm.meetings = []
  //     })
  //   }
  // },
  // async beforeRouteUpdate (to, from, next) {
  //   try {
  //     let resp = await Vue.http.get(`/api/admin/meetings?page=1&size=${this.pageSize}`)
  //     this.remoteStatus = resp.status
  //     this.totalCount = resp.body.totalCount
  //     this.totalPage = resp.body.totalPage
  //     this.meetings = resp.body.meetings
  //     this.searchKeyword = null
  //     next()
  //   } catch (e) {
  //     this.remoteStatus = e.status
  //     this.meetings = []
  //     next()
  //   }
  // }
}
</script>

<style lang="scss" >
  .meeting-list-card {
    .ivu-card-head p.meeting-list-title {
      display: flex;
      align-items: center;
      height: auto;
      min-height: 24px;
      line-height: 24px;
      overflow: visible;
    }
  }

  .all-meetings-switch {
    display: inline-flex;
    align-items: center;
    margin-left: 16px;
    font-weight: normal;

    .all-meetings-switch-label {
      margin-left: 8px;
    }
  }

  .meeting-list-extra {
    display: inline-flex;
    gap: 16px;
  }

  .meeting-date-filter-alert {
    margin-bottom: 12px;

    .ivu-btn {
      margin-left: 8px;
      padding: 0 4px;
    }
  }

  .link-btn {
    padding: 3px 7px;
    border: 1px solid #dcdee2;
    color: #515a6e;
    font-size: 12px;
    border-radius: 3px;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/meeting/List.vue